export default __webpack_public_path__ + "static/media/flag.669320cb.svg";